import { z } from "zod";
import { reviewBodySchema } from "./review-body-schema";

export const saveNewReviewSchema = {
  input: reviewBodySchema.omit({ _id: true }),
  output: z.literal("success"),
};
